import { Partner } from 'src/pages/partnership/types';
import { ContactCard } from '../contacts';
import { EventListItem } from '../events';
import { Service } from '../services';
import { VacancyModel } from '../work';

export interface CustomPageViewData {
  id: string;
  title: string;
  description: string;
}

export interface CustomPageMenuItem extends CustomPageViewData {
  slug: string;
}

export const enum PageEntityType {
  Partners = 0,
  Event = 1,
  Service = 2,
  ContactCard = 3,
  Vacancy = 4,
  Banner = 5,
  TextBlock = 6
}

export interface CustomPageBase extends CustomPageViewData {
  slug: string;
  draft: boolean;
  isDeleted: boolean;
  createdAt?: number;
  modifiedAt?: number;
  modifiedBy?: string;
}

export interface CustomPageView extends CustomPageBase {
  blocks: CustomPageBlock[];
  useInMenu: boolean;
  menuName?: string;
}

export interface CustomPageBlock extends CustomPageBase, CustomPageTextBlockModel {
  type: PageEntityType;
  order: number;
  pageId: string;
  services: Service[];
  contacts: ContactCard[];
  events: EventListItem[];
  partners: Partner[];
  vacancies: VacancyModel[];
}

export interface CustomPageTextBlockModel {
  showRequest?: boolean;
  requestText?: string;
  imgUrl?: string;
}
